import React from 'react';
import { useEnergyMarketPriceContext } from 'components/MarketEnergyTariffs/Context';
import { Label, Icon } from 'semantic';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { formatCurrency } from 'utils/formatting';

export default function MarketEnergyTariffLabel({
  currency,
}: {
  currency: string;
}) {
  const { t } = useTranslation();
  const context = useEnergyMarketPriceContext();

  if (context.loading) {
    return null;
  }

  if (
    !context.activeTariff ||
    typeof context.currentTariffFormatted?.rawPrice !== 'number'
  ) {
    return (
      <Label
        error
        content={
          <>
            {t(
              'advancedTariff.noMarketPrices',
              'Current market prices are not available.'
            )}
          </>
        }
      />
    );
  }

  return (
    <Modal
      trigger={
        <Label
          color="blue"
          style={{ display: 'inline-block', margin: 0, cursor: 'pointer' }}>
          <Icon name="chart-line" />
          {formatCurrency(
            context.currentTariffFormatted.rawPrice,
            currency
          )}{' '}
          {t('common.kWh', 'kWh')}
        </Label>
      }
    />
  );
}
